import Nav from '../../../Global/Nav.vue'
export default {
  name: 'DomainDetail',
  components: {
    Nav
  },
  data() {
    return {
      uploadApi: this.$axios.defaults.baseURL + 'websites/backend/upload',
      headersObj: {
        'x-authorization-token': this.$userinfo.api_token
      },
      activeName: 'records',
      loading: true,
      full_screen_loading: true,
      domain: '',
      recordsList: [],
      multipleRecordsSelection: [],
      recordsVisiable: false,
      recordLoading: false,
      recordTypeOptions: [
        'A',
        'CNAME',
        'MX',
        'TXT',
        'AAAA',
        'NS',
        'CAA',
        'SRV',
        'HTTPS',
        'SVCB',
        'SPF',
        '显性URL',
        '隐性URL'
      ],
      recordTtlOptions: [
        600,
        60,
        3600,
        86400,
        604800
      ],
      recordMxOptions: [
        0,
        5,
        10,
        50
      ],
      recordForm: {
        id: '',
        name: '',
        domain: '',
        type: 'A',
        value: '',
        ttl: 600,
        mx: 0
      },
      typeDescriptions: [
        { type: 'A', desc: '将域名指向一个 IPv4 地址，如 8.8.8.8' },
        { type: 'CNAME', desc: '将域名指向另一个域名地址，如 www.xxx.com' },
        { type: 'MX', desc: '用于邮件服务器，根据邮件注册商提供的信息填写' },
        { type: 'TXT', desc: '文本信息，常用于域名验证' },
        { type: 'AAAA', desc: '将域名指向一个 IPv6 地址，如 ff06::c3' },
        { type: 'NS', desc: '域名服务器记录，指定域名交由其他 DNS 服务商' },
        { type: 'CAA', desc: '指定证书颁发机构，减少证书颁发风险' },
        { type: 'SRV', desc: '用于标识某台服务器使用了某个服务' },
        { type: 'HTTPS', desc: 'HTTPS 服务绑定记录，提升安全性与性能' },
        { type: 'SVCB', desc: '新型服务绑定记录类型，可绑定多个客户端与参数' },
        { type: 'SPF', desc: '指定发送邮件的服务器，反垃圾邮件方案' },
        { type: '显性URL', desc: '域名重定向到网页并<span class="red">显示</span>实际 URL(301, 双向备案)' },
        { type: '隐性URL', desc: '域名重定向到网页并<span class="red">隐藏</span>实际 URL(301, 双向备案)' }
      ],
      recordFormRules: {
        name: [
          { required: true, message: '记录名不能为空', trigger: 'commit' },
          { max: 254, message: '长度不能超过 254 个字符', trigger: 'commit' },
          {
            validator: (rule, value, callback) => {
              if (!value) return callback();
              const validPattern = /^[0-9a-zA-Z\-*@_\u4e00-\u9fa5]+$/;
              if (!validPattern.test(value)) {
                return callback(new Error('主机记录仅允许 0-9, a-z, -, *, @, _, 中文字符'));
              }
              const starCount = (value.match(/\*/g) || []).length;
              if (starCount > 1) {
                return callback(new Error('"*" 只允许出现一次'));
              }
              const atCount = (value.match(/@/g) || []).length;
              if (atCount > 1) {
                return callback(new Error('"@" 字符只允许存在一位'));
              }
              if (atCount === 1 && value[0] !== '@') {
                return callback(new Error('"@" 字符只允许出现在主机记录的起始位置'));
              }
              callback();
            },
            trigger: 'commit'
          }
        ],
        value: [
          { required: true, message: '记录值不能为空', trigger: 'commit' }
        ]
      },
      whois: {
        registrant: {},
        name_servers: []
      },
      logsList: [],
      logsTotal: 0,
      logsPage: 1,
      logsSize: 20
    }
  },
  created() {
    this.domain = this.$route.params.domain;
    this.getRecords();
  },
  mounted() {
    this.getRecords();
  },
  methods: {
    tabClick(tab) {
      switch (tab.name) {
        case 'info':
          this.getRecords();
          break;
        case 'whois':
          this.getWhois();
          break;
        case 'logs':
          this.getLogs();
          break;
      }
    },
    async getRecords() {
      await this.$axios.get(`/tencent/dnspod/records?domain=${this.domain}`).then((response) => {
        this.loading = false;
        if (response.data.code === 200) {
          this.recordsList = response.data.data
        }
      })
    },
    copy(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    },
    recordsSelectionChange(val) {
      this.multipleRecordsSelection = val.map(item => item.record_id);
    },
    async recordsBatch(action) {
      if (this.multipleRecordsSelection.length > 0) {
        this.$confirm("确定要批量" + action + "吗?", '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          this.$axios.post(`/tencent/dnspod/records/toggle_status_batch`, {
            ids: this.multipleRecordsSelection,
            action: action,
            domain: this.domain
          }).then((response) => {
            this.loading = false;
            if (response.data.code === 200) {
              this.getRecords();
              this.$notify({
                title: '操作成功',
                message: "已保存",
                type: 'success'
              });
            }
          }).catch();
        })
      } else {
        this.$message({
          message: '未选择任何一条记录',
          type: 'error'
        });
      }
    },
    syncRecords() {
      this.loading = true;
      this.$axios.post(`/tencent/dnspod/records/sync`, { domain: this.domain }).then((response) => {
        this.loading = false;
        if (response.data.code === 200) {
          this.getRecords();
          this.$notify({
            title: '操作成功',
            message: '解析记录已经刷新',
            type: 'success'
          });
        }
      }).catch();
    },
    editRecords(record = null) {
      if (record !== null) {
        this.recordForm = {
          id: record.id,
          name: record.name,
          domain: this.domain,
          type: record.type,
          value: record.value,
          ttl: record.ttl,
          mx: record.mx
        }
      } else {
        this.recordForm = {
          id: '',
          name: '',
          domain: this.domain,
          type: 'A',
          value: '',
          ttl: 600,
          mx: 0
        }
      }
      this.recordsVisiable = true;
    },
    confirmEditRecord() {
      this.$refs.recordForm.validate(valid => {
        if (valid) {
          this.recordLoading = true;
          this.$axios.post(`/tencent/dnspod/records/save`, this.recordForm).then((response) => {
            this.recordLoading = false;
            if (response.data.code === 200) {
              this.getRecords();
              this.recordsVisiable = false;
              this.$notify({
                title: '操作成功',
                message: '已保存',
                type: 'success'
              });
            }
          }).catch();
        }
      })
    },
    deleteRecord(row) {
      this.$confirm("确定要删除" + row.name + "的" + row.type + "记录吗?", '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$axios.post(`/tencent/dnspod/records/delete`, { id: row.id }).then((response) => {
          this.loading = false;
          if (response.data.code === 200) {
            this.getRecords();
            this.$notify({
              title: '操作成功',
              message: row.name + "的" + row.type + "记录已删除",
              type: 'success'
            });
          }
        }).catch();
      })
    },
    toggleStatus(row) {
      this.loading = true;
      this.$axios.post(`/tencent/dnspod/records/toggle_status`, {
        id: row.id,
        domain: this.domain
      }).then((response) => {
        this.loading = false;
        if (response.data.code === 200) {
          this.getRecords();
          this.$notify({
            title: '操作成功',
            message: "已保存",
            type: 'success'
          });
        }
      }).catch();
    },
    async getWhois() {
      this.whois = {
        registrant: {},
        name_servers: []
      }
      this.full_screen_loading = true;
      this.loading = true;
      this.$axios.get(`/tencent/dnspod/whois?domain=${this.domain}`).then((response) => {
        this.full_screen_loading = false;
        this.loading = false;
        if (response.data.code === 200) {
          this.whois = response.data.data;
        }
      }).catch();
    },
    destroyDomain() {
      this.$axios.post(`/tencent/dnspod/destroy`, {
        domain: this.domain
      }).then((response) => {
        // if (response.data.code === 200) {
        //   this.whois = response.data.data;
        // }
      }).catch();
    },
    async getLogs() {
      this.loading = true;
      await this.$axios.get(`/tencent/dnspod/logs`, {
        params: {
          domain: this.domain,
          page: this.logsPage,
          size: this.logsSize
        }
      }).then((response) => {
        this.loading = false;
        if (response.data.code === 200) {
          this.logsList = response.data.data.data;
          this.logsTotal = response.data.data.total;
        }
      });
    },
    changeLogsSize(val) {
      this.logsSize = val;
      this.getLogs();
    },
    currentLogsChange(val) {
      this.logsPagePage = val;
      this.getLogs();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Modules/Websites/DomainsDetail/script.js